<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='我的订单'">
    <div class="list">
      <div class="item border-box" v-for="(item,index) in root" :key="index">
        <div class="item-t bold">{{item.name}}  <font v-if="item.protype==2"> ({{item.num}}人团)</font>
          <span class="fr state1" v-if="item.order_state==10">待支付</span>
          <span class="fr state2" v-if="(item.order_state==11||item.order_state==13)&&(item.type==1||item.type==8)">已关闭</span>
          <span class="fr state1" v-if="item.order_state==12&&item.type==2">待接单</span>
          <span class="fr state1" v-if="item.order_state==12&&item.type==3">拼团中</span>
          <span class="fr state1" v-if="item.order_state==12&&item.type==4">待使用</span>
          <span class="fr state1" v-if="item.order_state==12&&item.type==5">进行中</span>
          <span class="fr state1" v-if="item.order_state==12&&item.type==6">待评价</span>
          <span class="fr state2" v-if="item.order_state==12&&item.type==7">已完成</span>
          <span class="fr state2" v-if="item.order_state==15">已退款</span>
        </div>
        <div class="item-m border-box box" @click="toOrderDesc(item.ordernum)">
          <img class="img l" :src="item.logo" alt="">
          <div class="flex">
            <div class="text" v-if="item.protype==1"><span>出行人数：</span>{{item.people}}</div>
            <div class="text" v-if="item.protype==2"><span>购买数量：</span>{{item.buynum}}</div>

            <div class="text"><span>总价：</span>￥{{item.totalmoeny}}</div>
            <div class="text" v-if="item.time"><span>预约时间：</span>{{item.time.slice(5)}} {{item.stime}}-{{item.etime}}</div>
          </div>
        </div>
        <div class="item-b border-box box" v-if="item.protype==2&&item.order_state==12&&item.type==3">
          <div class="flex item-b-l box">
            <div class="item-b-img" v-if="item.peoples && item.peoples.length>0">
              <img class="fl img" :src="ite.headimg" alt="" v-for="(ite,ind) in item.peoples" :key="ite.name" v-if="ind<3">
              <img class="fl icon-dian" src="../../assets/icon-dian.png" alt="" v-if="item.peoples.length>=3">
            </div>
            <div class="item-b-info flex tr">
              <div class="t1" v-if="item.num - item.people>0">还差<font class="cor-p">{{item.num - item.people}}人</font>成团</div>
              <div class="t1" v-if="item.num - item.people<=0"><font class="cor-p">有用户待支付</font></div>
              <!--<div class="t2">剩余00:00</div>-->
            </div>
          </div>
          <!--<div class="item-b-r btn linear tc">邀请好友</div>-->
          <div class="item-b-r btn tc line" @click="cancelOrderFun(item.ordernum)">取消订单</div>
        </div>
        <div class="item-b border-box" v-else-if="(item.order_state==10||item.order_state==12)&&(item.type==1||item.type==6||item.type==7) || ((item.type==2||item.type==4)&&item.protype==1)">
          <div class="item-b-r fr btn tc linear" @click="getPayMoneyFun(index)" v-if="item.order_state==10">支付</div>
          <div class="item-b-r fr btn tc line" @click="cancelPayFun(index)" v-if="item.order_state==10">取消支付</div>
          <div class="item-b-r fr btn tc linear" @click="signOrder(index)" v-if="item.order_state==12&&item.type==4&&item.isSign&&!item.sign">签到</div>
          <div class="item-b-r fr btn tc line" @click="cancelOrderFun(item.ordernum)" v-if="item.order_state==12&&(item.type==2||item.type==4)&&item.protype==1">取消订单</div>
          <div class="item-b-r fr btn tc linear" @click="toComment(item.ordernum)" v-if="item.order_state==12&&(item.type==6||item.type==7)">评价</div>
          <div class="item-b-r fr btn tc line" @click="toPiao(item.ordernum,item.ispiao,item.piaotype)" v-if="item.protype==1&&item.order_state==12&&(item.type==6||item.type==7)">{{item.ispiao==1?'发票详情':'申请开票'}}</div>
        </div>
      </div>
    </div>
    <div class="load-tip">
      <p>
        <span class="l"></span>
        <span class="m">{{loadText}}</span>
        <span class="r"></span>
      </p>
    </div>

    <img class="to-home" src="../../assets/to-home.png" @click="toHome" alt="">

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import {getUserOrderList, getPayCancel,userSign} from "@/service/getData";
  import {wxGetPosition,wxShareme, payMoney} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        loadText: "数据加载中",
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        orderState: '', //支付订单状态 10 待支付 11 取消支付 12 支付成功 13 超时取消 14 退款申请 15 退款成功
        type: '', //产品订单状态 1 未支付 2已支付(等待接单) 3拼团中 4待使用 5进行中 6待评价 7已完成 8游客取消 9景区取消
        page: 1, //加载更多
        pageSize:10,
        root:[],//订单列表
        P400: 0, //系统维护中
      }
    },
    computed: {},

    created(){
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.getUserOrderListFun(this.page);

      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {
      async getUserOrderListFun(page){
        let res = await getUserOrderList({
          openid: this.userInfo.openid,
          orderState: this.orderState || '',
          pageNum: page,
          pageSize: this.pageSize,
          type: this.type,
      time: (new Date().getTime())
        });

        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.total
          var root = res.data;
          for(var i=0; i<root.length; i++){
            var item = root[i];
            if(this.bjDate(item.time+' '+item.stime)){
              root[i].isSign = true;
            }else {
              root[i].isSign = false;
            }
          }

          if (page >= Math.ceil(this.total / this.pageSize)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }
        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.getUserOrderListFun(page);
          });
        })
      },

      //判断当前时间是否在签到时间内
      bjDate(date1) {
        var date = new Date();
        if (date1) {
          if (typeof date1 === 'string') {
            date1 = new Date(date1.replace(/-/g, "/"));
          } else if (typeof date1 === 'number') {
            date1 = new Date(date1);
          }
        }
        var time = date1.getTime() - date.getTime();
        return (time>0 && time<=(7200*1000))?true:false;
      },

      //取消支付
      cancelPayFun: function (ind){
        var self = this;
        this.$confirm({
          title: '提示',
          content: '确认要取消支付吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            self.getPayCancelFun(ind)
          }
        }).catch(function(res){
          if(res == 'success') {
            self.getPayCancelFun(ind)
          }
        })
      },
      //取消支付
      async getPayCancelFun(ind){
        let res = await getPayCancel({
          ordernum: this.root[ind].ordernum
        });
        if(res.errcode == "00000"){
          this.root[ind].type=8;
          this.root[ind].order_state=11;
          this.$toast("取消成功")
        }else{
          this.$toast(res.errmsg)
        }
      },

      //对待支付订单重新发起支付
      getPayMoneyFun: function (ind){
        var self = this;
        payMoney(self,this.root[ind].ordernum,function(data){
          if(data){
            self.root[ind].type=2;
            self.root[ind].order_state=12;
          }
        })
      },

      //签到
      signOrder: function (ind){
        var self = this;
        this.$confirm({
          title: '提示',
          content: '确认要签到此订单吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            self.userSignFun(ind)
          }
        }).catch(function(res){
          if(res == 'success') {
            self.userSignFun(ind)
          }
        })
      },
      //确定签到
      async userSignFun(ind){
        let res = await userSign({
          ordernum: this.root[ind].ordernum
        });
        if(res.errcode == "00000"){
          this.root[ind].sign = 1;
          this.$toast("签到成功")
        }else{
          this.$toast(res.errmsg)
        }
      },

      //取消订单
      cancelOrderFun: function (ordernum){
        this.$router.push({
          path: `/order-refund?${'ordernum='+ ordernum+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },

      //跳转至评论页面
      toComment:function(ordernum){
        this.$router.push({
          path: `/comment?${'ordernum='+ ordernum+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },
      //跳转至订单详情页面
      toOrderDesc:function(ordernum){
        this.$router.push({
          path: `/order-desc?${'ordernum='+ ordernum+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },
      //跳转到发票页面
      toPiao:function (ordernum,ispiao,piaotype){
        this.$router.push({
          path: `/piao?${'ordernum='+ ordernum+'&ispiao='+ispiao+'&piaotype='+piaotype+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },

      //返回至首页
      toHome(){
        this.$router.replace({path: `/?scenicId=`+this.scenicId+'&scenicKey='+this.scenicKey });
      },


    },
    watch: {},
    components: {
        P400
    }
  }

</script>

<style scoped>
  .page{min-height:100vh;padding: .24rem .3rem .4rem;background: #ededed;}
  .item{margin-top:.24rem;padding:0 .3rem;background: #fff;border-radius: .2rem;}
  .item:first-child{margin-top: 0;}
  .item .item-t{height:1rem;font:.32rem/1rem "Microsoft YaHei";color: #333;border-bottom:1px solid #e3e3e3;}
  .item .state1{font-size: .28rem;color: #fa4f45;}
  .item .state2{font-size: .28rem;color: #999;}
  .item-m{padding: .2rem 0;border-bottom:1px solid #e3e3e3;}
  .item-m .img{width: 1.48rem;height: 1.48rem;margin-right:.2rem;border-radius: .06rem;object-fit:cover;overflow: hidden;}
  .item-m .flex{padding-top:.06rem;font: .28rem/.46rem "Microsoft YaHei";color: #333;}
  .item-m .flex span{color: #666;}
  .item-b{height: 1.32rem;}
  .item-b .btn{width: 2rem;height: .72rem;margin-left:.12rem;margin-top:.28rem;text-align: center;font: .32rem/.72rem "Microsoft YaHei";}
  .item-b .btn:last-child{margin-left: 0;}
  .item-b-img .img{width: .52rem;height: .52rem;margin-top:.38rem;margin-left:-.06rem;border-radius: 50%;border:.02px solid #fff;object-fit:cover;overflow: hidden;}
  .item-b-img .icon-dian{height: .06rem;margin-top: .63rem;margin-left: .1rem;}
  .item-b-info{font-size: .22rem;color: #333;margin-right: .24rem;margin-top: .36rem;}
  .item-b-info .t1{padding-top: .13rem;}
</style>



// WEBPACK FOOTER //
// src/page/home/order-list.vue